import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SpotlightCardCornerTag',
  props: {
    text: null,
    small: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})